import React from 'react';

interface IFmsReferenceFilesContext {
  cancel: () => Promise<boolean>,
};

const defaultState:IFmsReferenceFilesContext = {
  cancel: async () => false,
};

const IFmsReferenceFilesContext = React.createContext<IFmsReferenceFilesContext>(defaultState);

export default IFmsReferenceFilesContext;
